import { ModelType } from '../../models/ModelItem';

// Brand pairs: white on navy is 17.7:1 and navy on coral 5.3:1. White on
// coral is only 3.3:1, so the coral chip carries navy text.
export const labelsColors = {
  cyan: '#071834',
  pink: '#FF4A4A',
};

export const labelsTextColors: Record<keyof typeof labelsColors, string> = {
  cyan: '#FFFFFF',
  pink: '#071834',
};

export type Model = {
  name: string;
  model: string;
  type: ModelType;
  color: keyof typeof labelsColors;
  description: string;
  output?: string;
  more_description: string;
  useCases: { title: string; text: string; icon: string }[];
  requirements: string;
  illus: React.ReactNode;
};
